export const CAMERA_TYPES = {
  deteccao: {
    key: 'deteccao',
    title: 'Câmera de Detecção',
    subtitle: 'Acesse as câmeras de detecção cadastradas ou informe outro endereço IP.',
    icon: 'video',
  },
  monitoramento: {
    key: 'monitoramento',
    title: 'Câmera de Monitoramento',
    subtitle: 'Acesse as câmeras de monitoramento cadastradas ou informe outro endereço IP.',
    icon: 'eye',
  },
};

export function normalizeCameraUrl(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `http://${trimmed.replace(/^\/+/, '')}`;
}

export function isValidCameraInput(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return false;

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      return Boolean(url.hostname);
    } catch (_) {
      return false;
    }
  }

  const hostPattern = /^([\w.-]+|\d{1,3}(?:\.\d{1,3}){3})(:\d+)?(\/.*)?$/;
  return hostPattern.test(trimmed);
}
